module.exports = __webpack_public_path__ + "img/android_opera.799cba50.gif";